import { FC } from 'react';
import { ProductInfoType } from '../../types/product-info-type';
import classes from '../../asset/css/subscription-detail/product-list.module.css';
import { ProductInfo } from './ProductInfo';

export const RegisteredProductList: FC<{
  productInfos: ProductInfoType[];
  loading: boolean;
  changeActiveFunc: (active: boolean, variantId: string, planId?: string, lineId?: string) => void;
  updateQuantityFunc: (lineId: string, quantity: number) => void;
}> = ({ productInfos, loading, changeActiveFunc, updateQuantityFunc }) => {
  const productInfosHtml = productInfos.map((productInfo, idx) => {
    return (
      <ProductInfo
        active={true}
        loading={loading}
        productInfo={productInfo}
        key={idx}
        changeActiveFunc={changeActiveFunc}
        updateQuantityFunc={updateQuantityFunc}
      />
    );
  });

  return (
    <>
      <div className={classes.mypage_subsc_list_section}>
        <h4 className={classes.mypage_subsc_list_title}>次回お届け予定の商品</h4>
        <ul className={classes.mypage_subsc_list}>{productInfosHtml}</ul>
      </div>
    </>
  );
};
